import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import { DateProvider } from "@/context/DateContext";
import { Shell } from "@/components/layout/Shell";
import { ProtectedRoute } from "@/components/layout/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import AuditPage from "@/pages/AuditPage";
import OffersPage from "@/pages/OffersPage";
import SimulatePage from "@/pages/SimulatePage";
import Bet365Page from "@/pages/Bet365Page";
import ReviewPage from "@/pages/ReviewPage";
import RaceViewPage from "@/pages/RaceViewPage";
import ManualResultsPage from "@/pages/ManualResultsPage";
import ManualResultsEditorPage from "@/pages/ManualResultsEditorPage";
import BrisChartsPage from "@/pages/BrisChartsPage";
import BrisPpPage from "@/pages/BrisPpPage";

function App() {
    return (
        <ThemeProvider>
            <DateProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        <Route element={<ProtectedRoute />}>
                            <Route element={<Shell />}>
                                <Route path="/" element={<Navigate to="/audit" replace />} />
                                <Route path="/audit" element={<AuditPage />} />
                                <Route path="/offers" element={<OffersPage />} />
                                <Route path="/simulate" element={<SimulatePage />} />
                                <Route path="/bet365" element={<Bet365Page />} />
                                <Route path="/review" element={<ReviewPage />} />
                                <Route path="/race/:raceId" element={<RaceViewPage />} />
                                <Route path="/manual-results" element={<ManualResultsPage />} />
                                <Route path="/manual-results/:raceId" element={<ManualResultsEditorPage />} />
                                <Route path="/bris-charts" element={<BrisChartsPage />} />
                                <Route path="/bris-pp" element={<BrisPpPage />} />
                            </Route>
                        </Route>
                        <Route path="*" element={<Navigate to="/audit" replace />} />
                    </Routes>
                </BrowserRouter>
            </DateProvider>
        </ThemeProvider>
    );
}

export default App;
